import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import AreaDetailsListItem from './AreaDetailsListItem';
import LeadingEmployers from './LeadingEmployers';
import Contacts from './Contacts';
import MetroDistances from './MetroDistances';
import Utility from './Utility';
import Colleges from './Colleges';
import Transportation from './Transportation';
import Taxation from './Taxation';
import YesNoUnknown from '../../PropertyDetail/YesNoUnknown';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';


function isObjectNullOrEmpty(obj, keysToDisplay) {
  if (!obj) {
    return true;
  }
  for (let i = 0; i < keysToDisplay.length; i += 1) {
    if (obj[keysToDisplay[i]] !== null && obj[keysToDisplay[i]] !== undefined && obj[keysToDisplay[i]] !== ''
      && obj[keysToDisplay[i]] !== '0' && obj[keysToDisplay[i]] !== '0.00' && obj[keysToDisplay[i]] !== -1) {
      return false;
    }
  }
  return true;
}

function isArrayNullOrEmpty(array, displayProperties) {
  return array.map(item => {
    return isObjectNullOrEmpty(item, displayProperties);
  });
}

// If this gets any more complex, we should break these into their own components
export const menus = [
  // business climate
  {
    name: 'Business Climate',
    parent: 'Basic Info',
    shouldShow: ({ businessClimate } = {}) =>
      businessClimate && !isObjectNullOrEmpty(businessClimate, ['summary']),
    buildComponent: ({ businessClimate } = {}) =>
      <p>{businessClimate.summary}</p>,
  },
  // business growth status
  {
    name: 'Business Growth Status',
    parent: 'Basic Info',
    shouldShow: ({ businessGrowthStatus } = {}) => businessGrowthStatus && businessGrowthStatus !== '',
    buildComponent: ({ businessGrowthStatus } = {}) => <p>{businessGrowthStatus}</p>,
  },
  // contacts
  {
    name: 'Contacts',
    parent: 'Contacts',
    shouldShow: ({ contacts = [] } = {}) => contacts && contacts.filter(c => c.name !== '').length,
    buildComponent: ({ contacts = [] } = {}) =>
      <Contacts contacts={contacts} />,
  },
  // education
  {
    name: 'Education',
    parent: 'Basic Info',
    shouldShow: ({
                   education: {
                     actCompositeScore,
                     studentsTakingAct,
                     summary,
                     colleges = [],
                   } = {},
                 } = {}) =>
      (colleges && colleges.filter(c => c.name !== '').length)
      || (actCompositeScore && actCompositeScore !== '')
      || (studentsTakingAct && studentsTakingAct !== '')
      || (summary && summary !== ''),
    buildComponent: ({
                       education: {
                         actCompositeScore,
                         studentsTakingAct,
                         summary,
                         colleges = [],
                       } = {},
                     } = {}) => (
                       <div>
                         {
          actCompositeScore && actCompositeScore !== '' &&
          <div>
            <h3 style={{ marginTop: '5px' }}>Average ACT Score</h3>
            <p>{actCompositeScore}</p>
          </div>
        }
                         {
          studentsTakingAct && studentsTakingAct !== '' &&
          <div>
            <h3 style={{ marginTop: '5px' }}>Students Taking ACT (%)</h3>
            <p>{studentsTakingAct}</p>
          </div>
        }
                         {
          summary && summary !== '' &&
          <div>
            <h3 style={{ marginTop: '5px' }}>Summary</h3>
            <p>{summary}</p>
          </div>
        }
                         <Colleges colleges={colleges} show={colleges.length > 0} />
                       </div>
    ),
  },
  // environmental summary
  {
    name: 'Environmental Summary',
    parent: 'Basic Info',
    shouldShow: ({ environmental = {} } = {}) => environmental.summary && environmental.summary !== '',
    buildComponent: ({ environmental = {} } = {}) => <p>{environmental.summary}</p>,
    // this is missing logic to process "attainment" field in admin
  },
  // laborforce data
  {
    name: 'LaborForce Data',
    parent: 'Basic Info',
    shouldShow: ({ laborForceData = [] } = {}) => laborForceData && laborForceData.filter(l => l.name !== '').length,
    buildComponent: ({ laborForceData = [] } = {}) =>
      laborForceData.map(entry => <div key={entry.name}><p>{entry.name}</p><br /></div>),
  },
  // labor management
  {
    name: 'Labor Management',
    parent: 'Labor Management',
    shouldShow: ({ laborManagement: { info = {} } = {} } = {}) => (info.summary && info.summary !== '') || [0, 1].includes(info.rightToWorkState),
    buildComponent: ({ laborManagement: { info = {} } = {} } = {}) =>
      <div>
        <p>{info.summary}</p>
        {info.rightToWorkState != null &&
          <p>
            <strong>Right To Work State: </strong>
            <YesNoUnknown value={info.rightToWorkState} />
          </p>
        }
      </div>,
  },
  // leading employers
  {
    name: 'Leading Employers',
    parent: 'Basic Info',
    shouldShow: ({ leadingEmployers = [] } = {}) => leadingEmployers && leadingEmployers.filter(l => l.name !== '').length,
    buildComponent: ({ leadingEmployers = [] } = {}) =>
      <LeadingEmployers employers={leadingEmployers} />,
  },
  // metro distances
  {
    name: 'Metro Distances', // Communities
    parent: 'Metro Distances',
    shouldShow: ({ metroDistances = [] } = {}) => metroDistances && metroDistances.filter(l => l.city !== '').length,
    buildComponent: ({ metroDistances = [] } = {}) => <MetroDistances distances={metroDistances} />,
  },
  // quality of life
  {
    name: 'Quality Of Life',
    parent: 'Basic Info',
    shouldShow: ({ qualityOfLife = {} } = {}) => qualityOfLife.summary && qualityOfLife.summary !== '',
    buildComponent: ({ qualityOfLife = {} } = {}) => <p>{qualityOfLife.summary}</p>,
  },
  // taxation
  {
    name: 'Taxation',
    parent: 'Taxation',
    shouldShow: ({ taxation } = {}) =>
      taxation && !isObjectNullOrEmpty(taxation, Object.keys(taxation)),
    buildComponent: ({ taxation } = {}) => <Taxation taxation={taxation} />,
  },
  // transportation
  {
    name: 'Transportation',
    parent: 'Transportation',
    shouldShow: ({
                   transportation: {
                     commercialAirServices = [],
                     commercialAirport = [],
                     expressServices = [],
                     highways = [],
                     interstates = [],
                     motorCarriers = [],
                     publicTransportation = [],
                     railroads = [],
                     shippingServices = [],
                     waterway = [],
                   } = {},
                 } = {}) =>
      isArrayNullOrEmpty(commercialAirServices, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(commercialAirport, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(expressServices, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(highways, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(interstates, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(motorCarriers, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(publicTransportation, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(railroads, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(shippingServices, ['name', 'description']).includes(false)
      || isArrayNullOrEmpty(waterway, ['name', 'description']).includes(false),
    buildComponent: ({
                       transportation: {
                         commercialAirServices = [],
                         commercialAirport = [],
                         expressServices = [],
                         highways = [],
                         interstates = [],
                         motorCarriers = [],
                         publicTransportation = [],
                         railroads = [],
                         shippingServices = [],
                         waterway = [],
                       } = {},
                     } = {}) => (
                       <div>
                         <Transportation types={commercialAirServices} title="Commercial Air Services" show={commercialAirServices.length > 0} />
                         <Transportation types={commercialAirport} title="Commercial Airports" show={commercialAirport.length > 0} />
                         <Transportation types={highways} title="Highways" show={highways.length > 0} />
                         <Transportation types={motorCarriers} title="Motor Carriers" show={motorCarriers.length > 0} />
                         <Transportation types={publicTransportation} title="Public Transportation" show={publicTransportation.length > 0} />
                         <Transportation types={expressServices} title="Express Services" show={expressServices.length > 0} />
                         <Transportation types={interstates} title="Interstates" show={interstates.length > 0} />
                         <Transportation types={railroads} title="Railroads" show={railroads.length > 0} />
                         <Transportation types={shippingServices} title="Shipping Services" show={shippingServices.length > 0} />
                         <Transportation types={waterway} title="Waterways" show={waterway.length > 0} />
                       </div>
    ),
  },
  // utilities
  {
    name: 'Utilities', // Communities
    parent: 'Utilities',
    shouldShow: ({
      utilities: {
        electric = [],
        naturalGas = [],
        telecommunications = [],
        wasteWater = [],
        water = [],
      } = {},
    } = {}) =>
      isArrayNullOrEmpty(electric, ['name', 'phone', 'website']).includes(false)
      || isArrayNullOrEmpty(naturalGas, ['name', 'phone', 'website']).includes(false)
      || isArrayNullOrEmpty(telecommunications, ['name', 'phone', 'website']).includes(false)
      || isArrayNullOrEmpty(wasteWater, ['name', 'phone', 'website']).includes(false)
      || isArrayNullOrEmpty(water, ['name', 'phone', 'website']).includes(false),
    buildComponent: ({
      utilities: {
        electric = [],
        naturalGas = [],
        telecommunications = [],
        wasteWater = [],
        water = [],
      } = {},
    } = {}) => (
      <div>
        <Utility utilities={electric} title="Electric" show={electric.length > 0} />
        <Utility utilities={naturalGas} title="Natural Gas" show={naturalGas.length > 0} />
        <Utility utilities={telecommunications} title="Telecommunications" show={telecommunications.length > 0} />
        <Utility utilities={wasteWater} title="Waste Water" show={wasteWater.length > 0} />
        <Utility utilities={water} title="Water" show={water.length > 0} />
      </div>
    ),
  },
  // utility regulations
  {
    name: 'Utility Regulations', // States
    parent: 'Utilities',
    shouldShow: ({
      utilities: {
        electricAuthority,
        naturalGasAuthority,
        telecommunicationsAuthority,
        electricRegulated,
      } = {},
    } = {}) =>
      electricAuthority
      || naturalGasAuthority
      || telecommunicationsAuthority
      || electricRegulated,
    buildComponent: ({
      utilities: {
        electricAuthority,
        naturalGasAuthority,
        telecommunicationsAuthority,
        electricRegulated,
      } = {},
    } = {}) => (
      <div className="section-body">
        <ul>
          {electricAuthority &&
            <li>
              <strong>Electric Regulatory Authority: </strong>
                {electricAuthority}
            </li>
          }
          {naturalGasAuthority &&
            <li>
              <strong>Natual Gas Regulatory Authority: </strong>
                {naturalGasAuthority}
            </li>
          }
          {telecommunicationsAuthority &&
            <li>
              <strong>Telecommunications Regulatory Authority: </strong>
                {telecommunicationsAuthority}
            </li>
          }
          {electricRegulated !== undefined &&
            <li>
              <strong>State Electric Deregulated: </strong>
              <YesNoUnknown value={electricRegulated} />
            </li>
          }
        </ul>
      </div>
    ),
  },
];

export class AreaDetailsComponent extends Component {
  static propTypes = {
    overview: PropTypes.object,
    setDetailMenuLength: PropTypes.func,
    detailMenuLength: PropTypes.number,
    detailInfoToShow: PropTypes.arrayOf(PropTypes.string),
  }

  constructor(props) {
    super(props);
    this.state = { menu: { name: '', buildComponent: () => {} } };
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.detailMenuLength = this.props.detailMenuLength;
    this.availableMenus = [];
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.detailMenuLength !== this.availableMenus.length) {
      this.props.setDetailMenuLength(this.availableMenus.length);
      this.state.menu = this.availableMenus[0];
    }
  }

  handleMenuClick(menu) {
    this.setState({ menu });
  }

  render() {
    /* these checks against detailInfoToShow are needed to consume the admin config that
     determines which sections to display - detailInfoToShow is null when all sections
     are selected and returns array of section names only when only some are selected */
    const { detailInfoToShow } = this.props;
    this.availableMenus = menus.filter(menu => {
      return (
        (detailInfoToShow === null || (detailInfoToShow && detailInfoToShow.includes(menu.parent)))
        && menu.shouldShow(this.props.overview.details)
      );
    });
    return (
      this.availableMenus.length ? (
        <div className="state-details">
          <div className="detail-col-1">
            <div>
              <div className="property-images" />
              <ConditionalWrapper condition={this.availableMenus.length > 0}>
                <ul className="property-info state-list">
                  {this.availableMenus.map(menu =>
                    <AreaDetailsListItem
                      key={menu.name}
                      name={menu.name}
                      isActive={menu === this.state.menu}
                      onClick={() => this.handleMenuClick(menu)}
                    />,
                  )}
                </ul>
              </ConditionalWrapper>
            </div>
          </div>
          <div className="detail-col-2">
            <ViewerPrimaryColorUserStyle domStyle="color">
              <h4 className="section-title">{get(this.state, 'menu.name')}</h4>
            </ViewerPrimaryColorUserStyle>

            {this.state.menu.buildComponent(this.props.overview.details)}
          </div>
        </div>
      ) : (null)
    );
  }
}

export default AreaDetailsComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaDetails/AreaDetails.js